




































































































import { Component, Emit, Prop, PropSync } from 'nuxt-property-decorator'
import { BibliographySearchResultAuthorityItem } from '@/api'
import {
  Col,
  DataTableHeader,
  DataTable
} from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'
import { uniqueId } from 'lodash'

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'check',
        align: 'center'
      }
    ]
  },
  {
    width: 40,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    items: [
      {
        name: 'authorityNo',
        headerText: '{label}ＩＤ'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    items: [
      {
        name: 'display',
        headerText: '{label}'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'reference',
        headerText: '参照情報'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'specialty',
        headerText: '専門・世系等'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'yearOfBirth',
        headerText: '生没年'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'work',
        headerText: '職業・専門等'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'bibliographyCount',
        headerText: '書誌件数',
        align: 'right'
      }
    ]
  }
]

const COLS_SIMPLE: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'check',
        align: 'center'
      }
    ]
  },
  {
    width: 40,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    items: [
      {
        name: 'authorityNo',
        headerText: '{label}ＩＤ'
      }
    ]
  },
  {
    width: '50',
    resizable: true,
    items: [
      {
        name: 'display',
        headerText: '{label}'
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    items: [
      {
        name: 'reference',
        headerText: '参照情報'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'bibliographyCount',
        headerText: '書誌件数',
        align: 'right'
      }
    ]
  }
]

@Component({
  components: {
    DataTable,
    DataTableHeader,
    RecycleScroller
  }
})
export default class BibliographySearchResultsAuthorityTable extends DataTable {
  @Prop({
    type: Boolean,
    default: true
  })
  simple!: boolean

  @Prop({
    type: String,
    required: true
  })
  label!: string

  @Prop({
    type: Boolean
  })
  allSelect!: boolean

  @Prop({
    type: Array,
    required: true
  })
  items!: BibliographySearchResultAuthorityItem[]

  @PropSync('selected', {
    type: Array,
    default: () => []
  })
  selectedAuthorityNos!: string[]

  @Prop({
    type: Number,
    required: true
  })
  scrollTop!: number

  get itemsLength() {
    return this.items.length
  }

  get checkBoxName() {
    return uniqueId('bibliography-search-results-authority-table')
  }

  get showCols(): Col[] {
    const cols = this.simple ? COLS_SIMPLE : COLS

    return cols.map(col => {
      col.items[0].headerText = col.items[0].headerText?.replace(
        '{label}',
        this.label
      )
      return col
    })
  }

  get rowHeight(): number {
    return 34
  }

  get checked() {
    return (authorityNo: string) =>
      this.selectedAuthorityNos.includes(authorityNo)
  }

  onClickTableRow(authorityNo: string): void {
    this.onChangeCheck(authorityNo)
    this.onClickRow(
      this.items.findIndex(item => item.authorityNo === authorityNo)
    )
  }

  onChangeCheck(authorityNo: string) {
    if (this.selectedAuthorityNos.includes(authorityNo)) {
      const index = this.selectedAuthorityNos.findIndex(
        value => authorityNo === value
      )
      this.selectedAuthorityNos.splice(index, 1)
    } else {
      this.selectedAuthorityNos.push(authorityNo)
    }
  }

  @Emit('all-select')
  onChangeAllSelect() {}

  @Emit('scroll')
  onScroll(value: number): number {
    return value
  }
}
